import React, { useEffect } from 'react';
import Logo from '../assets/logo.png'
import instaLogo from '../assets/logo-insta.svg'
import faceLogo from '../assets/logo-face.svg'
import courses from '../config/courses'
import star from '../assets/star.svg'
import starComplete from '../assets/star-complete.svg'
import { useParams } from 'react-router'
import api from '../config/api'
import conta from '../assets/conta.svg'
import { useSelector, useDispatch } from 'react-redux'
import { actions } from '../store/reducers/userReducer'


export default function CoursePage({ history, params }) {
  const state = useSelector(state => state.userReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!state.logged) {
      const token = localStorage.getItem('token')
      
      if(token) {
        api.post('/authenticate', '', {
          headers: {
            token: token
          }
        })
        .then((response) => {
          response.data.logged = true
          dispatch(actions.setIfosUser(response.data))
        })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.message === "token invalid") {
              } else if (error.response.data.message === "token not declared") {
              } else if (error.response.data.message === "error in athentication") {
              }
          }
        })
      }
    } 
  }, []) // eslint-disable-line

  async function pagSeguro() {

    const infosPagseguro = {
      reference: courseName,
      description: `${title} - ${description}`,
      amount: "100.00"
    }

    const response = await api.post('/buy', infosPagseguro)

    const code = response.data.code

    var callback = {
      success: function (transactionCode) {
        //Insira os comandos para quando o usuário finalizar o pagamento. 
        //O código da transação estará na variável "transactionCode"
        console.log("Compra feita com sucesso, código de transação: " + transactionCode);
      },
      abort: function () {
        //Insira os comandos para quando o usuário abandonar a tela de pagamento.
        console.log("abortado");
      }
    };
    //Chamada do lightbox passando o código de checkout e os comandos para o callback
    window.PagSeguroLightbox(code, callback);
  }

  var title
  var description

  const { courseName } = useParams()
  if (courseName === 'enem') {
    title = 'Enem'
    description = 'Fique por dentro dos assuntos de matemática para o enem'
  } else if (courseName === '6ano') {
    title = '6° Ano'
    description = 'Aprenda tudo de matemática para o sexto ano'
  } else if (courseName === '7ano') {
    title = '7° Ano'
    description = 'Aprenda tudo de matemática para o sétimo ano'
  } else if (courseName === '8ano') {
    title = '8° Ano'
    description = 'Aprenda tudo de matemática para o oitavo ano'
  } else if (courseName === '9ano') {
    title = '9° Ano'
    description = 'Aprenda tudo de matemática para o nono ano'
  } else if (courseName === '1ano') {
    title = '1° Ano'
    description = 'Aprenda tudo de matemática para o primeiro ano do ensino médio'
  } else if (courseName === '2ano') {
    title = '2° Ano'
    description = 'Aprenda tudo de matemática para o segundo ano do ensino médio'
  }
  const atualCourse = courses[0];

  return (
    <div className="p-0 m-0">

      <nav className="navbar navbar-expand-lg navbar-dark bg-edited">

        <a className="navbar-brand" href="/">
          <img src={Logo} width="30" height="30" alt="Logo" />
        </a>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" href="/">Início</a>
            </li>
            <li className="nav-item active">
              <span className="nav-link" >{title}</span>
            </li>
          </ul>
        </div>

        <div>
        <a className="navbar-brand pb-2 socialLogos" href="https://www.facebook.com/profile.php?id=100002358731599" target="_blank" rel="noopener noreferrer">
          <img src={faceLogo} width="20" height="20" alt="faceLogo" />
        </a>
        <a className="navbar-brand pb-2 socialLogos" href="https://www.instagram.com/ousadoresolve/" target="_blank" rel="noopener noreferrer">
          <img src={instaLogo} width="20" height="20" alt="instaLogo" />
        </a>
        </div>

        {!state.logged && (
          <div>
            <button className="btn btn-outline-light mr-2 my-2 my-sm-0" onClick={() => (history.push('/signUp'))}>Registrar</button>
            <button className="btn btn-outline-light my-2 my-sm-0" onClick={() => (history.push('/login'))}>Login</button>

            <button className="navbar-toggler ml-3" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>)}

        {state.logged && (
          <div className='d-flex flex-column text-center'>
            <a className="navbar-brand socialLogos m-0 p-0" href={`/course/${courseName}`}>
              <img src={conta} width="40" height="40" alt="Logo" />
            </a>
            <span className='text-light'>{state.username}</span>
          </div>
        )}      

      </nav>

      <div className="container-fluid p-0 m-0">



        <div className='bg-edited-light'>
          <div className='container pt-4 pb-4'>

            <div className='course-info-page'>
              <h1>{title}</h1>
              <h5>{description}</h5>

            </div>
          </div>
        </div>

        <div className='div-card-course'>
          <div className="card card-course pt-2 pb-3">
            <div className="card-body">
              <h2 className="font-weight-bold">R$100,00</h2>
            </div>
            <button className="btn-lg btn btn-danger my-2 ml-4 mr-4 my-sm-0" onClick={() => { pagSeguro() }}>Comprar</button>
            <div className='ml-4 mr-4 mt-3'>

              <h6>Este curso inclui</h6>
              <h6 className='ml-2'>Acesso total vitalício</h6>
              <h6 className='ml-2'>Acesso no dispositivo móvel e no PC</h6>

            </div>
          </div>
        </div>

        <div className='bg-edited text-light container pt-3 pb-0'>
          <div className='course-info-page d-flex justify-content-between'>
            <h5 className='font-weight-bold' >Conteúdo do curso</h5>
            <div className='d-flex'>
              <h5 className='mr-4'>10 aulas</h5>
              <h5 className='text-muted'>12:05:04</h5>
            </div>
          </div>
        </div>

        <div className='container mt-0 p-0 mb-4 bg-edited'>
          <div className='course-info-page'>
            {atualCourse.topics.map((topic, indexTopic) => {

              const target = `#collapseExample-${indexTopic}-${topic.id}`
              const id = `collapseExample-${indexTopic}-${topic.id}`

              return (
                <ul className='list-groupb order-edited m-0 p-0 border-edited' key={topic.id}>

                  <div className='align-middle p-2 topic'>
                    <h6 className='text-light font-weight-bold text-H6' type="button" data-toggle="collapse" data-target={target} aria-expanded="false" aria-controls={target} >{topic.title}</h6>
                  </div>

                  <div className='collapse' id={id}>
                    {topic.lessons.map((lesson, indexLesson) => {
                      return (
                        <li key={lesson.id} type="button" className='list-lesson m-0 border-edited d-flex justify-content-between'>
                          <h6 className='text-light ml-3 pt-2 text-H6'>{lesson.title}</h6>
                          <h6 className='text-muted mr-3 pt-2 text-H6'>05:04</h6>
                        </li>
                      )
                    })}
                  </div>
                </ul>
              )
            })}
          </div>
        </div>

        <div className='bg-edited-light pt-4 pb-4'>
          <div className='container'>
            <div className='course-info-page'>

              <h5>Descrição</h5>
              <p>
                Este curso contém exemplos simples e práticos para você compreender ainda mais sobre as Classes,
                entrando em conceitos mais avançados como Herança, Polimorfismo, Classes Abstratas, Herança Múltipla,
                Friend Functions e muito mais. Com vídeo aulas curtas e muitas perguntas para testar seu conhecimento,
                você entenderá rapidamente esse tema tão importante para quem quer seguir na profissão de programador, saindo
                com uma ótima base de programação orientada a objetos.
            </p>

              <h5>Tópicos do curso:</h5>

              <h6>Revisão</h6>
              <h6>Herança - Parte 1</h6>
              <h6>Herança - Parte 2</h6>
              <h6>Classe Abstrata e Polimorfismo</h6>
              <h6>Herança Múltipla</h6>
              <h6>Interface (pure virtual class)</h6>
              <h6>Mais sobre Static</h6>
              <h6>Utilizando o conceito de Final</h6>
              <h6>Friend Functions</h6>
            </div>
          </div>
        </div>

        <div className='bg-edited pt-4 pb-4 container text-light'>
          <div className='course-info-page'>
            <h5>Notas</h5>
            <div className='d-flex'>
              <div className='w-50 text-center d-flex flex-column justify-content-center'>
                <h1>4.9</h1>

                <div>
                  <img src={starComplete} width="40" height="40" alt="star" />

                  <img src={starComplete} width="40" height="40" alt="star" />

                  <img src={starComplete} width="40" height="40" alt="star" />

                  <img src={starComplete} width="40" height="40" alt="star" />

                  <img src={star} width="40" height="40" alt="star" />
                </div>
              </div>

              <div className='w-100'>

                <div className='d-flex'>
                  <div className="progress bar">
                    <div className="progress-bar bg-info" role="progressbar" style={{ width: "59%" }} aria-valuenow="59" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div >
                    <img className='mt-2 ml-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <span className='rating-text'>59%</span>
                </div>

                <div className='d-flex'>
                  <div className="progress bar">
                    <div className="progress-bar bg-info" role="progressbar" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div >
                    <img className='mt-2 ml-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <span className='rating-text'>25%</span>
                </div>

                <div className='d-flex'>
                  <div className="progress bar">
                    <div className="progress-bar bg-info" role="progressbar" style={{ width: "12%" }} aria-valuenow="12" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div >
                    <img className='mt-2 ml-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <span className='rating-text'>12%</span>
                </div>

                <div className='d-flex'>
                  <div className="progress bar">
                    <div className="progress-bar bg-info" role="progressbar" style={{ width: "1%" }} aria-valuenow="1" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div >
                    <img className='mt-2 ml-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <span className='rating-text'>01%</span>
                </div>

                <div className='d-flex'>
                  <div className="progress bar">
                    <div className="progress-bar bg-info" role="progressbar" style={{ width: "3%" }} aria-valuenow="3" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div >
                    <img className='mt-2 ml-2' src={starComplete} width="25" height="25" alt="starComplete" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <div >
                    <img className='mt-2' src={star} width="25" height="25" alt="star" />
                  </div>
                  <span className='rating-text'>03%</span>
                </div>


              </div>
            </div>

          </div>
        </div>

      </div>

      <footer className="container-fluid page-footer bg-edited-light footer py-2">
        <div className="footer-copyright">
          Ousado Resolve © 2020 - Todos os direitos reservados
      </div>

        <div className=" footer-copyright">
          <a href="/"> Direitos autorais </a>
          -
        <a href="/"> Termos de uso </a>
          -
        <a href="/"> Política de privacidade </a>
        </div>

      </footer>

    </div>
  )
}